import { Injectable } from '@angular/core';
import { apiConstants } from "../constant/apiConstant";
import { commonFunctionService } from "../utils/commonFunctions";
import { AppSettings } from 'src/config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PendingFeesReportService {

    private URL_V3 = AppSettings.API_ENDPOINT_V3;
    headers: HttpHeaders;
    private language = "en";

    constructor(private http: HttpClient, private commonFunction: commonFunctionService) { }

    getAcademicYears() {
        return this.http
            .get(this.URL_V3 + apiConstants.getAcademicYearsList, {
                headers: this.commonFunction.appendHeader(),
                params: { lang: this.language },
            })
            .pipe(map((res) => res));
    }

    getStudentListData(classWingId, classCategoryId, classSectionId, gender, selectedYear) {
        const headers = this.commonFunction.appendHeader();
        return this.http.get(this.URL_V3 + `${apiConstants.getAcademicStudentListForPendingFeeApiEndpoint}/?lang=${this.language}&academicId=${selectedYear}&classCategoryId=${classWingId}&classStandardId=${classCategoryId}&classId=${classSectionId}&gender=${gender}`, { headers }).pipe(map(res => res));
    }

    getStatData(payload) {
        const headers = this.commonFunction.appendHeader();
        return this.http.get(this.URL_V3 + `${apiConstants.getPendingFeeStat}/?lang=${this.language}&academicId=${payload.selectedAcademicYearId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&classId=${payload.classId}&gender=${payload.gender}&studentIdList=${payload.studentList}`, { headers }).pipe(map(res => res));
    }

    getAllClassData(payload) {
        const headers = this.commonFunction.appendHeader();
        return this.http.get(this.URL_V3 + `${apiConstants.getPendingFeeAllClassData}/?lang=en&academicId=${payload.selectedAcademicYearId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&gender=${payload.gender}&pageLimit=${payload.limit}&pageNumber=${payload.pageNumber}`, { headers }).pipe(map(res => res));
    }

    getPendingFeeClassWiseData(payload) {
        const headers = this.commonFunction.appendHeader();
        return this.http.get(this.URL_V3 + `${apiConstants.getPendingFeeClassWiseData}/?lang=en&academicId=${payload.selectedAcademicYearId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&classId=${payload.classId}&gender=${payload.gender}&studentIdList=${payload.studentList}&pageNumber=${payload.pageNumber}&pageLimit=${payload.pageLimit}`, { headers }).pipe(map(res => res));
    }

    exportReportData(body) {
        const headers = this.commonFunction.appendHeader();
        return this.http.post(this.URL_V3 + `${apiConstants.exportFeePendingReport}`, body, { headers, responseType: 'blob' as 'json' }).pipe(map(res => res));
    }
}
